<template>
  <g transform="translate(2 2)">
    <path
      fill="currentColor"
      d="M33.585,30.453l-3.228,3.871-1.13-1.355A1.257,1.257,0,0,0,27.3,34.579l2.1,2.515a1.256,1.256,0,0,0,1.931,0l4.193-5.031a1.257,1.257,0,1,0-1.931-1.611Z"
      transform="translate(-21.344 -23.712)"
    /><path
      fill="currentColor"
      d="M10.062,0A10.062,10.062,0,1,0,20.124,10.062,10.062,10.062,0,0,0,10.062,0Zm0,17.608a7.546,7.546,0,1,1,7.546-7.546A7.546,7.546,0,0,1,10.062,17.608Z"
    />
  </g>
</template>
